/* eslint-disable */

import React from "react";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import { useEffect, useState } from "react";
import {
  fetchAccountPlanExecutions,
  fetchGraphQL,
} from "../../../services/api-raindrop.js";

import DateFormat from "../../../ui-components/date-format/date-format.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";
import { Link, useNavigate } from "react-router-dom";
import { ordinal } from "../../../logic/logic.js";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import Currency from "../../../ui-components/currency/currency.tsx";
import SettingsElement from "../../../ui-components/settings-element/settings-element.js";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import RaindropToggleWithTitle from "../../../ui-components/raindrop-toggle-with-title/raindrop-toggle-with-title.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";

const PauseDonationSection = ({ userCurrent, setUserCurrent = (x) => {} }) => {
  const onToggle = (newIsOn) => {
    const queryStr = `
      mutation {
        updateAccountPlan(
          isPaused: ${newIsOn}
        ) {
          id
        }
      }
    `;

    console.log("RD-54433", queryStr);

    fetchGraphQL(queryStr).then((response) => {
      if (response.errors) {
        console.log("RD-332", response.errors);
      }

      console.log("Updating local usercurrent");

      setUserCurrent((oldUserCurrent) => {
        return {
          ...oldUserCurrent,
          account: {
            ...oldUserCurrent.account,
            accountPlan: {
              ...oldUserCurrent.account.accountPlan,
              isPaused: newIsOn,
            },
          },
        };
      });
    });
  };

  return (
    <RaindropCard>
      <RaindropToggleWithTitle
        title="Pause donation"
        subtitle="You can restart at any time"
        onToggle={onToggle}
        initialIsOn={userCurrent.account.accountPlan.isPaused}
      />
    </RaindropCard>
  );
};

const AccountPlanExecutionListElement = ({ id, executedAt }) => {
  const navigate = useNavigate();
  return (
    <RaindropClickable
      onClick={() => {
        navigate(`/raindrop/settings/contribution/${id}`);
      }}
    >
      <RaindropCard additionalClasses="w-full">
        <div className="flex flex-row justify-center items-center w-full ">
          <FlexCol tailwindGap="gap-0" className="w-full">
            <RaindropTextSubtitle className="w-full">
              Contribution for
            </RaindropTextSubtitle>
            <RaindropTextHeading1 className="w-full">
              <DateFormat dateIsoString={executedAt} />
            </RaindropTextHeading1>
          </FlexCol>
          <Spacer />
          <i className={`fa fa-chevron-right text-xl`} />
        </div>
      </RaindropCard>
    </RaindropClickable>
  );
};

const ReceiptSection = ({ localAccountPlanExecutions }) => {
  return (
    <div className="flex flex-col w-full gap-6">
      <RaindropTextHeading1>Receipts</RaindropTextHeading1>
      {localAccountPlanExecutions.length === 0 && (
        <RaindropTextParagraph>
          No receipts to show just yet
        </RaindropTextParagraph>
      )}
      {localAccountPlanExecutions &&
        localAccountPlanExecutions.map((accountPlanExecution) => (
          <AccountPlanExecutionListElement
            key={accountPlanExecution.id}
            id={accountPlanExecution.id}
            subunits={accountPlanExecution.subunits}
            subunitsCurrency={accountPlanExecution.subunits_currency}
            executedAt={accountPlanExecution.executed_at}
            executionSausages={accountPlanExecution.execution_sausages}
          />
        ))}
    </div>
  );
};

const RaindropContributions = ({
  accountId,
  userCurrent,
  setUserCurrent = (x) => {},
}) => {
  const [localAccountPlanExecutions, setLocalAccountPlanExecutions] =
    useState(null);

  const [activePlan, setActivePlan] = useState(null);

  const isRaindropPlus = activePlan?.isSupportingRaindrop;

  useEffect(() => {
    fetchAccountPlanExecutions({
      accountId: userCurrent.account.id,
    }).then((data) => {
      setLocalAccountPlanExecutions(data);
    });
  }, [userCurrent]);

  useEffect(() => {
    fetchGraphQL(`
      query {
        account(
          id: "${accountId}"
        ) {
          accountPlan {
            subunits
            isPaused
            subunitsCurrency
            contributionDay
            isSupportingRaindrop
          }
        }
      }
    `).then((result) => {
      setActivePlan(result.data.account.accountPlan);
    });
  }, [userCurrent]);

  if (localAccountPlanExecutions == null || activePlan == null) {
    return <RaindropLoadingElement />;
  }

  return (
    <RaindropPage hasBackNavigation={true}>
      <RaindropTextHeading2>Your contributions</RaindropTextHeading2>

      <RaindropCard>
        <RaindropHeading title="Your contribution" isSecondary={true} />
        <SettingsElement
          title={"Amount"}
          isClickable={true}
          value={
            <Currency
              subunits={activePlan.subunits}
              currency={activePlan.subunitsCurrency}
            />
          }
          to={"/raindrop/settings/contributions/update-amount"}
        />
        <SettingsElement
          title={"Version"}
          isClickable={true}
          value={isRaindropPlus ? "Raindrop Plus" : "Basic"}
          to="/raindrop/upgrade"
        />
        <SettingsElement
          title={"Contribution day"}
          value={`${ordinal(activePlan.contributionDay)} of each month`}
          isClickable={false}
        />
      </RaindropCard>

      <PauseDonationSection
        userCurrent={userCurrent}
        setUserCurrent={setUserCurrent}
      />

      <ReceiptSection localAccountPlanExecutions={localAccountPlanExecutions} />
    </RaindropPage>
  );
};

export default RaindropContributions;
